import Icon from '@mui/icons-material/Clear';
import { SvgIconPropsOverrides } from '../../../model/icon';

export default function ClearIcon({ className = '', ...props }: SvgIconPropsOverrides) {
	return <Icon className={`${className}`} {...props} />;
}
